import { registerVerifier } from './orchestrator'
import { registry } from './orchestrator'

import sms from './verifiers/sms'
import email from './verifiers/email'

registerVerifier('sms_validate', async () => sms)
registerVerifier('email_validate', async () => email)

registerVerifier('app_validate', () =>
  import('./verifiers/app').then((m) => (m as any).default ?? m),
)
registerVerifier('biometric_validate', () =>
  import('./verifiers/webauthn').then((m) => (m as any).default ?? m),
)

// 未注册类型给出友好的调试提示（生产环境可去掉）
export async function preloadVerifier(type: string) {
  const loader = registry.get(type)
  if (!loader) {
    if (import.meta.env.DEV) console.warn('[MFA] 未注册验证器：', type)
    return
  }
  await loader()
}
